import { Controller } from "@hotwired/stimulus"
import Inputmask from 'inputmask'

export default class extends Controller {
  static targets = ["input"]
  static values = { 
    regex: { type: String, default: '^https://[^\\\\s]+$' },
    placeholder: { type: String, default: '' },
    showMaskOnHover: { type: Boolean, default: true },
    showMaskOnFocus: { type: Boolean, default: true },
    clearIncomplete: { type: Boolean, default: true }
  }

  connect() {
    this.initializeUrlMask()
  }

  disconnect() {
    this.removeMask()
  }

  initializeUrlMask() {
    this.inputTargets.forEach(input => {
      this.setupMask(input)
    })
  }

  setupMask(input) {
    try {
      // Get configuration from data attributes or use values
      const regex = input.dataset.inputmaskRegex || this.regexValue
      const placeholder = input.dataset.inputmaskPlaceholder || this.placeholderValue
      
      const maskOptions = {
        regex: regex,
        placeholder: placeholder,
        showMaskOnHover: this.showMaskOnHoverValue,
        showMaskOnFocus: this.showMaskOnFocusValue,
        clearIncomplete: this.clearIncompleteValue,
        onBeforePaste: (pastedValue) => {
          return this.handlePaste(pastedValue)
        }
      }
      
      // Apply the mask
      const mask = Inputmask(maskOptions)
      mask.mask(input)
      
      // Store mask reference for cleanup
      input._urlMask = mask
      
    } catch (error) {
      console.error('Failed to initialize URL field mask:', error)
    }
  }

  handlePaste(pastedValue) {
    // Auto-add https:// if user pastes a URL without protocol
    if (pastedValue && !pastedValue.startsWith('http://') && !pastedValue.startsWith('https://')) {
      return 'https://' + pastedValue
    }
    return pastedValue
  }

  removeMask() {
    this.inputTargets.forEach(input => {
      if (input._urlMask) {
        input._urlMask.remove()
        delete input._urlMask
      }
    })
  }

  // Public method to reinitialize masks (useful for dynamic forms)
  reinitialize() {
    this.removeMask()
    this.initializeUrlMask()
  }

  // Method to add mask to new inputs (for dynamic forms)
  addToNewElement(newElement) {
    const newInputs = newElement.querySelectorAll('[data-url-field="true"]')
    newInputs.forEach(input => {
      this.setupMask(input)
    })
  }

  // Target callbacks for dynamic content
  inputTargetConnected(input) {
    // Set up mask when new input targets are added
    if (!input._urlMask) {
      this.setupMask(input)
    }
  }

  inputTargetDisconnected(input) {
    // Clean up mask when input targets are removed
    if (input._urlMask) {
      input._urlMask.remove()
      delete input._urlMask
    }
  }
}